import React, { useState } from "react";
import SalesImageSection from "./SalesImageSection";
import SalesContactInfo from "./SalesContactInfo";
import SalesQueryForm from "../../pages/salesQueryForm/SalesQueryForm";
const SalesQuery = () => {
  return (
    <div className="container mt-4">
      <div className="row align-items-center">
        <SalesImageSection />
        <div className="col-12 col-lg-6 mt-3 mt-lg-0">
          <SalesQueryForm />
        </div>
        <SalesContactInfo />
      </div>
    </div>
  );
};

export default SalesQuery;
